import Vue from "vue";
import Vuex from "vuex";

import api from "@/api";

import auth from "./modules/auth";
import employees from "./modules/employees";
import accounts from "./modules/accounts";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    employees,
    accounts
  },
  state: {
    foo: "bar",
    accounts: [],
    categories: [], // JSON.parse(localStorage.getItem('categories')) || [],
    tokenDrive: localStorage.getItem("tokenDrive") || "",
    designers: []
  },
  getters: {
    getCategories: state => state.categories
  },
  mutations: {
    setAccounts(state, accounts) {
      state.accounts = accounts;
    },
    setCategories(state, categories) {
      state.categories = categories;
    },
    setTokenDrive(state, tokenDrive) {
      state.tokenDrive = tokenDrive;
    },
    setDesingers(state, designers) {
      state.designers = designers;
    }
  },
  actions: {
    fetchAccounts({ commit }) {
      return new Promise((resolve, reject) => {
        api({
          method: "get",
          url: "accounts",
          params: {
            sort: "number",
            limit: 1000
          }
        })
          .then(res => {
            // console.log("fetchAccounts", res.data);
            commit("setAccounts", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchCategories({ commit }) {
      return new Promise((resolve, reject) => {
        api({
          method: "get",
          url: "categories",
          params: {
            limit: 1000
          }
        })
          .then(res => {
            // console.log("fetchCategories", res.data);
            commit("setCategories", res.data.rows);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchTokenDrive({ commit }) {
      return new Promise((resolve, reject) => {
        api({
          method: "get",
          url: "drive"
        })
          .then(res => {
            // console.log("fetchTokenDrive", res.data);
            localStorage.setItem("tokenDrive", res.data.token);
            commit("setTokenDrive", res.data.token);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    fetchDesingers({ commit }) {
      return new Promise((resolve, reject) => {
        api({
          method: "get",
          url: "users",
          params: {
            role: "designer",
            limit: 1000
          }
        })
          .then(res => {
            // console.log("fetchDesingers", res.data);
            commit("setDesingers", res.data);
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  }
});
